import { api } from '../config/base-api';

export interface PostCheckoutSessionParams {
  cartId: string;
  previousCartId?: string;
  name: string;
  email: string;
  phone: string;
  leadId: string;
  additionalData?: {
    dataForm?: object;
    dataLead?: object;
  };
}

export async function postCheckoutSession(params: PostCheckoutSessionParams): Promise<void> {
  await api.post('/api/v1/sessions/checkout', params);
}
